import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Radio,
  RadioGroup,
  Button,
  Typography,
  FormControl,
} from '@mui/material'

const CreateClaimConfirmation = ({
  open,
  handleToggleClaimConfirmation,
  handleCancelOrder,
  value,
  setValue,
}) => {
  const handleChange = (e) => {
    setValue(e.target.value)
  }
  return (
    <>
      <Dialog
        open={open}
        aria-labelledby='customized-dialog-title'
        PaperProps={{
          style: {
            borderRadius: '20px',
            width: '24rem',
            height: '15rem',
          },
        }}
      >
        <DialogTitle>
          <Typography sx={{ fontWeight: 700, fontSize: 20, textAlign: 'center' }}>
            Eligible to File Claim
          </Typography>
        </DialogTitle>
        <DialogContent>
          <FormControl sx={{ display: 'flex', justifyContent: 'space-evenly' }}>
            <RadioGroup
              value={value}
              onChange={handleChange}
              sx={{
                '&.MuiRadioGroup-root': {
                  display: 'flex',
                  justifyContent: 'space-evenly',
                  flexDirection: 'row',
                },
              }}
            >
              <FormControlLabel value={1} control={<Radio />} label='Yes' sx={{ width: '3rem' }} />
              <FormControlLabel
                value={0}
                control={<Radio />}
                label='No'
                sx={{ width: '3rem!important' }}
              />
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
          <Button variant='contained' onClick={() => handleCancelOrder()}>
            Submit
          </Button>
          <Button variant='outlined' onClick={() => handleToggleClaimConfirmation()}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
export default CreateClaimConfirmation
